import React from "react";

const HeadingDialog = ({ heading }) => {
  return (
    <h2 className="text-dark-blue font-figtree text-xl text-center font-semibold max-lg:text-base pb-4">
      {heading}
    </h2>
  );
};
export default HeadingDialog;
